import React, { useState, useEffect } from 'react'
import { Collapse } from '@mui/material'
import * as lib from '../../../../js/lib/lib.js'
import ExtrasApp from '../../Booking/components/ExtrasApp.js'

const ExtrasFields = () => {
  const { dictionary } = window.modifyData
  const [toggleCollapse, setToggleCollapse] = useState(false)

  const handleCollapseClick = () => {
    if (lib.scrDevices()) {
      setToggleCollapse((old) => !old)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      if (!lib.scrDevices()) {
        setToggleCollapse(true)
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <>
      <div className="s-booking-form__form-group">
        <div className="row" onClick={handleCollapseClick}>
          <div className="col-lg-6 mb-24 d-flex align-items-center justify-content-between">
            <span className="s-booking-form__form-group__title">
              {dictionary.extrasTitle}
            </span>
            <div className="d-lg-none ">
              <i
                className={`icon-arrow-down arrow ${
                  toggleCollapse ? 'open' : ''
                }`}
              />
            </div>
          </div>
        </div>

        <Collapse in={toggleCollapse}>
          <ExtrasApp parentCollapseOpen={toggleCollapse} />
        </Collapse>
      </div>
    </>
  )
}

export default ExtrasFields
